import React, { useEffect, useState } from "react";
import { Container, Hero, ArticleContainer } from "./styled";
import { Articles } from "../../components";
import { Link } from "react-router-dom";
import { Loader } from "../../../components";

const Main = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    window
      .fetch(`https://graphql.contentful.com/content/v1/spaces/ynl21amwlp74/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authenticate the request
          Authorization: `Bearer ${process.env.REACT_APP_CONTENTFULL_AUTH}`,
        },
        // send the GraphQL query
        body: JSON.stringify({ query }),
      })
      .then((response) => response.json())
      .then(({ data, errors }) => {
        if (errors) {
          console.error(errors);
        }
        // rerender the entire component with new data
        setArticles(data.blogPostCollection.items);
      });
  }, []);

  return (
    <Container>
      {!articles ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          <Hero />
          <ArticleContainer>
            {articles.map((article, i) => (
              <Link
                //to={`/blog/article/${article?.sys.id}`}
                to={{
                  pathname: "/blog/article/" + article?.title,
                  state: { id: article?.sys.id },
                }}
                key={`article-${i}`}
              >
                <Articles data={article} key={i} />
              </Link>
            ))}
          </ArticleContainer>
        </>
      )}
    </Container>
  );
};

export default Main;

const query = `
{
  blogPostCollection {
    items {
      sys {
        id
      }
      title
      description
      postContent{
        json
      }
      publishDate
      author
      postTags
      enableComments
      comments
      mediaCollection {
        items {
          url
          title
        }
      }
    }
  }
}
`;
